import React, { ReactNode } from "react";
import { Dialog, IconButton } from "@mui/material";
import { Close } from "@mui/icons-material";
import { MaxWidth } from "../types";
import "./styles.scss";
import { iconClose } from "assets/images";

export interface IModalProps {
  id?: string;
  open: boolean;
  handleClose?: React.MouseEventHandler<HTMLButtonElement>;
  children?: ReactNode;
  fullWidth?: boolean;
  maxWidth?: MaxWidth;
  className?: string;
}

export const Modal: React.FC<IModalProps> = ({
  id,
  open,
  children,
  handleClose,
  fullWidth = true,
  maxWidth = "sm",
  className = "",
}: IModalProps) => {
  return (
    <Dialog
      id={id}
      onClose={handleClose}
      open={open}
      className={`modal ${className}`}
      fullWidth={fullWidth}
      maxWidth={maxWidth}
    >
      <div>
        <IconButton className="modal-close" onClick={handleClose}>
          {/* <Close /> */}
          <img src={iconClose} alt="" />
        </IconButton>
        {children}
      </div>
    </Dialog>
  );
};

export default Modal;
